import './zone-flag';
import 'zone.js';
import '@angular/localize/init';
require('../manifest.webapp');
